import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Card, CardBody, Col, Input, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { useGetItemClasses } from "../hooks";
import { DesktopContainer } from "../layouts";
import { api, constants, helpers } from "../utils";
import { MachinePartTypeahead, PORawMaterialDropDown, ServiceThreadSpinner, SpinnerButton, VendorTypeahead } from "./";


export default function NoBomPoPlanning(props) {
   const cancelToken = axios.CancelToken;
   const source = cancelToken.source();
   const ClassList = useGetItemClasses({ IsNonBOMClassCode: true });

   const [classFunctionList, setClassFunctionList] = useState([]);
   const [downloading, setDownloading] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [screenFields, setScreenFields] = useState({
      planningList: [],
      itemOrderList: [],
      payload: {
         abcCode: { value: 0, label: "---All---" },
         classCode: { value: "-1", label: "---All---" },
         vendor: null,
         itemNumberChecked: true,
         itemDescriptionPartialChecked: false,
         itemNumber: "",
         itemDescriptionPartial: "",
         sortDirection: "",
         sortField: "",
         orderRange: { label: "One Week", value: "7" },
         excludeInTransit: true,
      },
      page: {
         number: 1,
         size: 25,
         total: 0,
         itemOrderListPrestine: [],
      },
      sortDirection: "asc",
      sortField: "",
   });

   useEffect(() => {
      if (!ClassList.Success) return;
      const list = _.cloneDeep(ClassList.ClassList);
      if (_.isArray(list)) {
         list.unshift({ value: "-1", label: "---All---" });
         const orderedList = _.orderBy(list, (x) => x.label);
         setClassFunctionList(orderedList);
      } else {
         setClassFunctionList([]);
      }
   }, [ClassList]);

   function CreatePayload() {
      const classCode = screenFields.payload.classCode.value;
      const abcCode = screenFields.payload.abcCode.value;
      const orderRange = screenFields.payload.orderRange.value;
      if (typeof classCode !== "string") {
         toast.error("incorrect classCode format");
      }
      if (typeof abcCode !== "number") {
         toast.error("incorrect abcCode format");
      }
      if (typeof orderRange !== "string")
         toast.error("incorrect orderangeFormat");
      let payload = Object.assign(
         {
            ItemDescription: screenFields.payload.itemDescriptionPartial,
            ItemNumber: screenFields.payload.itemNumber?.value || "",
            ABCCode: abcCode,
            ClassCode: classCode,
            VendorId: screenFields.payload.vendor
               ? screenFields.payload.vendor.value
               : screenFields.payload.vendor,
            OrderRange: orderRange,
            ExcludeInTransit: screenFields.payload.excludeInTransit,
         },
         {}
      );
      return payload;
   }

   const LoadPlanningTable = () => {
      if (!ClassList.Success) return;
      setIsLoading(true);
      api
         .postS("Purchasing/NoBomPoPlanning", CreatePayload(), source.token)
         .then((response) => {
            if (response.data?.success) {
               if (response.data.rawMaterialPlanningList.length) {
                  const copy = _.cloneDeep(screenFields);
                  const data = response.data?.rawMaterialPlanningList;
                  //count the total months
                  setScreenFields({
                     ...copy,
                     planningList: data,
                     itemOrderList: [],
                  });
               } else {
                  setScreenFields({
                     ...screenFields,
                     planningList: [],
                     itemOrderList: [],
                  });
               }
            } else {
               throw new Error(response);
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setIsLoading(false);
         });
   };

   const onChange = (property, value, copy = null) => {
      if (copy === null) copy = _.cloneDeep(screenFields);
      _.set(copy, property, value);
      setScreenFields(copy);
      return;
   };

   const onExportToXlsx = () => {
      setDownloading(true);
      const payload = CreatePayload();

      api
         .postGetBlob("Purchasing/ExportNoBomPlanning", payload)
         .then((r) => {
            if (r.data.success === false) {
               if (_.isString(r.data.message)) {
                  toast.error(r.data.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = `PO Planning non-BOM.xlsx`;
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx);
            } else {
               toast.error(r.message || "There was an error downloading the machine parts planning report");
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error("There was an error downloading the machine parts planning report");
         })
         .finally(() => setDownloading(false));
   };

   const pageSpecificSorting = (state) => {
      const { sortField, sortDirection } = state;
      const data = _.orderBy(
         screenFields.planningList,
         [sortField, "orderQuantityNeeded"],
         [sortDirection, "desc"]
      );

      setScreenFields({
         ...screenFields,
         sortDirection: sortDirection,
         sortField: sortField,
         planningList: data,
      });
   };

   const RadioButtonTypeAhead = (
      currentValue,
      PropertyToBecomeTrue,
      PropertyToBecomeFalse,
      PropertyToBecomeNull
   ) => {
      if (currentValue) return; // no need to switch it is already true
      const copy = _.cloneDeep(screenFields);
      _.set(copy, PropertyToBecomeTrue, true);
      _.set(copy, PropertyToBecomeFalse, false);
      _.set(copy, PropertyToBecomeNull, "");
      setScreenFields(copy);
   };

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   return (
      (document.title = `Non-BOM Planning`),
      (
         <DesktopContainer screenName={"PO Planning Non-BOM items"}>
            <div className="filter-header stick-top mb-3">
               <Row xs="" className="mt-3">
                  <Col xs="3" style={{ textAlign: "right", marginTop: "6px", color: "white" }}>
                     Class:
                  </Col>
                  <Col xs="6">
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={classFunctionList}
                        value={screenFields.payload.classCode}
                        onChange={(opt) => onChange("payload.classCode", opt)}
                     />
                  </Col>
               </Row>

               <Row xs="" className="mt-3">
                  <Col xs="3" style={{ textAlign: "right", marginTop: "6px", color: "white" }}>
                     ABC Code:
                  </Col>
                  <Col xs="6">
                     <Select
                        classNamePrefix="serviceThreadSelect"
                        options={ClassList.ABCCodeList}
                        value={screenFields.payload.abcCode}
                        onChange={(opt) => onChange("payload.abcCode", opt)}
                     />
                  </Col>
               </Row>

               <Row xs="" className="mt-3">
                  <Col xs="3" style={{ textAlign: "right", marginTop: "6px", color: "white" }}>
                     Vendor:
                  </Col>
                  <Col xs="6">
                     <VendorTypeahead
                        value={screenFields.payload.vendor}
                        onChange={(opt) => onChange("payload.vendor", opt)}
                     />
                  </Col>
               </Row>

               <Row className="mt-3">
                  <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }}>
                     Item Number:
                  </Col>
                  <Col xs="1" style={{ paddingRight: "0px" }}>
                     <Input
                        type="checkbox"
                        name={"ItemNumber"}
                        checked={screenFields.payload.itemNumberChecked}
                        onChange={() =>
                           RadioButtonTypeAhead(
                              screenFields.payload.itemNumberChecked,
                              "payload.itemNumberChecked",
                              "payload.itemDescriptionPartialChecked",
                              "payload.itemDescriptionPartial"
                           )
                        }
                     />
                  </Col>
                  <Col xs="4">
                     <MachinePartTypeahead
                        value={screenFields.payload.itemNumber}
                        onChange={(opt) => onChange("payload.itemNumber", opt)}
                        disabled={screenFields.payload.itemDescriptionPartialChecked}
                     />
                  </Col>
                  <Col xs="4"></Col>
               </Row>

               <Row className="mt-2">
                  <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }}>
                     Item Description Partial:
                  </Col>
                  <Col xs="1" style={{ paddingRight: "0px" }}>
                     <Input
                        type="checkbox"
                        name={"ItemDescriptionPartial"}
                        checked={screenFields.payload.itemDescriptionPartialChecked}
                        onChange={() =>
                           RadioButtonTypeAhead(
                              screenFields.payload.itemDescriptionPartialChecked,
                              "payload.itemDescriptionPartialChecked",
                              "payload.itemNumberChecked",
                              "payload.itemNumber"
                           )
                        }
                     />
                  </Col>
                  {screenFields.payload.itemDescriptionPartialChecked &&
                     <Col xs="4">
                        <Input
                           type="text"
                           name={"ItemDescriptionPartial"}
                           value={screenFields.payload.itemDescriptionPartial}
                           disabled={screenFields.payload.itemNumberChecked}
                           onChange={(e) => { onChange("payload.itemDescriptionPartial", e.target.value); }}
                        />
                     </Col>
                  }
               </Row>
               <Row className="mt-3">
                  <Col>
                     <Row>
                        <Col xs="3"></Col>
                        <Col>
                           <Button
                              className="shredButton"
                              style={{ marginRight: "15px" }}
                              onClick={LoadPlanningTable}
                              disabled={isLoading}
                           >
                              SHOW PLANNING
                           </Button>
                        </Col>
                        <Col xs="3"></Col>
                     </Row>
                  </Col>
               </Row>
            </div>
            <Card className="dashboard-card">
               <CardBody>
                  <ServiceThreadSpinner on={isLoading}>
                     {screenFields && screenFields.planningList?.length !== 0 && (
                        <>
                           <Row className="align-items-center mb-2">
                              <Col className="transparent-background">
                                 <ButtonGroup className="float-end">
                                    <SpinnerButton
                                       title="Download as .xlsx"
                                       className="shredButtonExcel float-end ms-2"
                                       onClick={onExportToXlsx}
                                       on={downloading}
                                       disabled={downloading}
                                    >
                                       <FontAwesomeIcon icon="file-excel" size="lg" />
                                    </SpinnerButton>
                                 </ButtonGroup>
                              </Col>
                           </Row>
                           <Table size="sm" className="data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Item"}
                                          field={"itemNumber"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "itemNumber"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "itemNumber",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Class"}
                                          field={"itemClass"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "itemClass"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "itemClass",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={
                                             <span>ABC<br />Code</span>
                                          }
                                          field={"abcDisplayCode"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "abcCode"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "abcCode",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Vendor"}
                                          field={"vendorNumber"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "vendorNumber"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "vendorNumber",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={
                                             <span>Add<br />Qty<br />Needs</span>
                                          }
                                          field={"orderQuantityNeeded"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "orderQuantityNeeded"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "orderQuantityNeeded",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Site"}
                                          field={"site"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "site"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "site",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"On Hand"}
                                          field={"rawTotalOnHand"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "rawTotalOnHand"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "rawTotalOnHand",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"On POs"}
                                          field={"rawTotalOrdered"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "rawTotalOrdered"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "rawTotalOrdered",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Needed"}
                                          field={"productionQuantityNeeded"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "productionQuantityNeeded"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "productionQuantityNeeded",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Order Point"}
                                          field={"rawTotalOrderPoint"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "rawTotalOrderPoint"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "rawTotalOrderPoint",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Fixed Order Qty"}
                                          field={"rawTotalFixedOrderQty"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "rawTotalFixedOrderQty"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "rawTotalFixedOrderQty",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                    <th>
                                       <PageSpecificSortHeader
                                          displayName={"Lead Time"}
                                          field={"planningLeadTime"}
                                          sortDirection={screenFields.sortDirection}
                                          sorted={screenFields.sortField === "planningLeadTime"}
                                          callback={pageSpecificSorting}
                                          state={{
                                             sortField: "planningLeadTime",
                                             sortDirection:
                                                screenFields.sortDirection === "asc"
                                                   ? "desc"
                                                   : "asc",
                                          }}
                                       />
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(screenFields.planningList, (datum, index) => {
                                    return (
                                       <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                          <td>
                                             <Link style={{ textDecoration: "none", display: "block" }}
                                                className="shredLink fw-bold"
                                                target="_blank"
                                                to={`/inventoryDashboard/${JSON.stringify({
                                                   value: datum.itemNumber,
                                                   label: datum.itemWithDesc,
                                                }, replacer)}`}
                                             >{datum.itemWithDesc}</Link>
                                          </td>
                                          <td>{datum.itemClass}</td>
                                          <td>{datum.abcDisplayCode}</td>
                                          <td>{datum.vendorNumber}</td>
                                          <td>{Math.round(datum.orderQuantityNeeded).toLocaleString()}</td>
                                          <td>{datum.site}</td>
                                          <td>{Math.round(datum.rawTotalOnHand).toLocaleString()}</td>
                                          {datum.rawTotalOrdered === 0 ? (
                                             <td>{Math.round(datum.rawTotalOrdered).toLocaleString()}</td>
                                          ) : (
                                             <PORawMaterialDropDown
                                                itemNumber={datum.itemNumber}
                                                rawTotalOrdered={datum.rawTotalOrdered}
                                             />
                                          )}
                                          <td>{Math.round(datum.productionQuantityNeeded).toLocaleString()}</td>
                                          <td>{Math.round(datum.rawTotalOrderPoint).toLocaleString()}</td>
                                          <td>{Math.round(datum.rawTotalFixedOrderQty).toLocaleString()}</td>
                                          <td>{Math.round(datum.planningLeadTime).toLocaleString()}</td>
                                       </tr>
                                    );
                                 })}
                              </tbody>
                           </Table>
                        </>
                     )}
                  </ServiceThreadSpinner>
               </CardBody>
            </Card>
            <br /><br /><br /><br /><br /><br />
         </DesktopContainer>
      )
   );
}

function PageSpecificSortHeader(props) {
   const [direction, setDirection] = useState(props.sortDirection || "asc");

   useEffect(() => {
      setDirection(props.sortDirection || "asc");
   }, [props.sortDirection]);

   const callBackDir = direction === "desc" ? "asc" : "desc";

   return (
      <span
         className="sort-handle"
         onClick={() =>
            props.state
               ? props.callback(props.state)
               : props.callback(props.field, callBackDir)
         }
      >
         {props.displayName}
         {props.sorted && direction === "asc" && (
            <FontAwesomeIcon icon="angle-up" className="ms-1" />
         )}
         {props.sorted && direction === "desc" && (
            <FontAwesomeIcon icon="angle-down" className="ms-1" />
         )}
      </span>
   );
}
